import { render, staticRenderFns } from "./parkingAreastatus.vue?vue&type=template&id=63a46d83&scoped=true"
import script from "./parkingAreastatus.vue?vue&type=script&lang=js"
export * from "./parkingAreastatus.vue?vue&type=script&lang=js"
import style0 from "./parkingAreastatus.vue?vue&type=style&index=0&id=63a46d83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a46d83",
  null
  
)

export default component.exports